import { useMutation } from "@tanstack/react-query";
import TenantHandler from "../handlers/tenant";

const useGetUserGameInfo = (onSuccess, onFailure) => {
	const tenantHandler = new TenantHandler();

	const { data, isPending, isSuccess, isError, error, mutate } = useMutation({
		mutationFn: (payload) => tenantHandler.getUserGameInfo(payload),
		mutationKey: ["get_user_game_info"],
		onSuccess: onSuccess,
		onError: onFailure,
	});

	return { data, isPending, isSuccess, isError, error, mutate };
};

export default useGetUserGameInfo;
